import styles from './discussion-body.module.css'

import * as React from 'react'

import { RichTextEditor } from '@disco/shared-components/rich-text-editor'

import type { DiscussionBody as DiscussionBodyType } from 'types/discussion'

import { TRACK_NOTE_TOOLBAR_ITEMS } from './toolbar-items'

type Props = {
  body: DiscussionBodyType | null
  trackDurationSeconds?: number
  onTimestampClick?: (timestamp: string) => void
}

const DiscussionBody = ({
  body,
  trackDurationSeconds,
  onTimestampClick,
}: Props): React.ReactElement | null => {
  if (!body) return null
  return (
    <RichTextEditor
      type="track"
      readOnly
      showToolbar={false}
      customToolbar={TRACK_NOTE_TOOLBAR_ITEMS}
      trackDurationSeconds={trackDurationSeconds}
      className={styles.commentBody}
      initialContent={
        body as React.ComponentProps<typeof RichTextEditor>['initialContent']
      }
      onTimestampClick={onTimestampClick}
    />
  )
}

export default DiscussionBody
